import type { ReactNode } from "react";
import { Navigate } from "react-router-dom";
import type { Role } from "./types";
import { useAuth } from "./useAuth";

/**
 * Route guard by role. Without `roles`, any platform role is enough (users
 * still waiting for approval go to /pending). Platform admins pass every check.
 * The API enforces the same rules; this only decides what to show.
 */
export default function RequireRole({ roles, children }: { roles?: Role[]; children: ReactNode }) {
  const { isPending, isPlatformAdmin, hasRole } = useAuth();

  if (isPending) return <Navigate to="/pending" replace />;
  if (roles && !isPlatformAdmin && !hasRole(...roles)) return <Navigate to="/" replace />;
  return children;
}
